import { render, staticRenderFns } from "./growthSalesLedger.vue?vue&type=template&id=efbef916&scoped=true"
import script from "./growthSalesLedger.vue?vue&type=script&lang=js"
export * from "./growthSalesLedger.vue?vue&type=script&lang=js"
import style0 from "./growthSalesLedger.vue?vue&type=style&index=0&id=efbef916&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efbef916",
  null
  
)

export default component.exports